//import logo from './logo.svg';
import './App.css';

import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
//import { Route, Switch } from "react-router";

//import Welcome from './pages/Welcome';
//import Products from './pages/Products';
import Signin from './pages/Signin/Signin';


import CompanyList from './pages/CompanyList/CompanyList';
import SubCompanyList from './pages/CompanyList/SubCompanyList';
import AffiliatedCompany from './pages/AffiliatedCompany/AffiliatedCompany';
import HotelList from './pages/Hotel/Hotel';

import TickerList from './pages/BotTicker/TickerList';




import UserControl from './pages/UserControl/UserControl';
import TravelClickSetting from './pages/TravelClickApi/TravelClickApiUpdate';
import SmtpSetting from './pages/SmtpSetting/SmtpSettingUpdate';
import HopinnSetting from './pages/HopinnSetting/HopinnSettingUpdate';

import AdyenSetting from './pages/AdyenSetting/AdyenSettingUpdate';

import CompanyPolicy from './pages/CompanyPolicy/CompanyPolicy';
import CompanyEmployeeGroup from './pages/CompanyEmployeeGroup/CompanyEmployeeGroup';
//import CompanyPolicyDetails from './pages/CompanyPolicy/CompanyPolicyUpdate';


import TravelClickApiLog from './pages/TravelClickApiLog/TravelClickApiLog';
import AdyenApiLog from './pages/AdyenApiLog/AdyenApiLog';
import OtherApiLog from './pages/OtherApiLog/OtherApiLog';
import BotHopinnLog from './pages/BotHopinnLog/BotHopinnLog';


import Workflow from './pages/Workflow/bookinglist';
import StatementList from './pages/Statement/statementlist';

import ReservationByBilling from './pages/WorkflowBilling/reservationlist';


import BookingDetails from './pages/Workflow/bookingdetails';
import BookingDetailsForStatement from './pages/Statement/bookingdetails';
import CompanyUserControl from './pages/CompanyUserControl/CompanyUserControl';
import OpenApiUpdate from './pages/OpenApi/OpenApiUpdate';

import CompanySettingUpdate from './pages/CompanySetting/CompanySettingUpdate';

import SearchUserCompany from './pages/UserCompany/SearchUserCompany';


// import Template from './components/Template';
// import TemplateCompany from './components/TemplateCompany';
import * as utils from './Utils.js';

import CompanyEmployee from './pages/CompanyEmployee/CompanyEmployee';
import CompanyCostCenter from './pages/CompanyCostCenter/CompanyCostCenter';

import CompanyCode from './pages/CompanyCode/CompanyCode';

import BillingList from './pages/WorkflowBilling/billinglist';

import CompanyLog from './pages/LogReport/CompanyLog';

import EmailHistoryList from './pages/EmailHistory/EmailHistoryList';

import RoomCode from './pages/RoomCode/RoomCode';


//import TemplateCompany from './components/TemplateCompany';
//import MainHeader from './components/MainHeader';
//mport  { Redirect } from 'react-router-dom'
//require('dotenv').config();


//function App() {

//alert(process.env.REACT_APP_API_KEY);

//alert("app");
// return (
//   <div className="App">
//     <header className="App-header">
//       <img src={logo} className="App-logo" alt="logo" />
//       <p>
//         Edit <code>src/App.js</code> and save to reload.
//       </p>
//       <a
//         className="App-link"
//         href="https://reactjs.org"
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         Learn React
//       </a>
//     </header>
//   </div>
// );

class App extends Component {

  constructor(props) {
    //alert("Hotel");
    super(props);
    this.state = {
      userObject: null,
      logout: this.logout,
      checkUser: this.checkUser,
      checkRoles: this.checkRoles
    };
    //alert("app")
  }


  logout = () => {

    //console.log("logout");
    //console.log(this.state.userObject);

    if (this.state.userObject != null) {
      let userObject = this.state.userObject;

      let data = {};
      let token = userObject.Token;

      data.Id = userObject.userId;
      data.Token = userObject.Token;
      let url = process.env.REACT_APP_API_END_POINT + "/api/Corp/Logout";
      utils.callPost(url, token, data, this.logoutCallBack);
    }
    else {
      window.localStorage.removeItem("userObject");
      window.location.reload();
    }

    //window.localStorage.removeItem("userObject");
    //window.location.reload();
  }


  logoutCallBack = () => {
    window.localStorage.removeItem("userObject");
    //window.location.reload();
    var url = "/management/signin";
    window.location.replace(url);
  }


  checkUser = (appState) => {


    var url = "/management/signin?request_url=" + window.location;

    let userObject = appState.userObject;


    if (userObject === null) {
      if (window.localStorage.getItem('userObject') === null) {
        window.location.replace(url);
      }
      else {
        let userObject = JSON.parse(localStorage.getItem("userObject"));
        appState.userObject = userObject;
        appState.languageCode = userObject.languageCode;



        //let userObject = JSON.parse(localStorage.getItem("userObject"));
        //appState.userObject = userObject;
        //appState.languageCode = userObject.languageCode;

        // if(appState.userObject.UserType !== 1){
        //   window.location.replace(url);
        // }
        this.setState({
        })
      }
    }






    //console.log("check user");
    //console.log(appState);


    //var location = window.location;
    //var url = "/management/signin?request_url="+location;


    // let userObject = appState.userObject;
    // if (userObject === null) {
    //   if (window.localStorage.getItem('userObject') === null) {
    //     window.location.replace(url);
    //   }
    //   else {
    //     //let userObject = JSON.parse(localStorage.getItem("userObject"));
    //     //appState.userObject = userObject;
    //     //appState.languageCode = userObject.languageCode;

    //     // if(appState.userObject.UserType !== 1){
    //     //   window.location.replace(url);
    //     // }
    //     this.setState({
    //     })
    //   }
    // }







    //console.log(appState);



    this.loadDic("EN_US");
  }

  checkRoles = (appState, roles) => {
    let userObject = appState.userObject;
    let check = false;

    for (let i = 0; i < roles.length; i++) {
      let test = utils.IsInRole(userObject, roles[i]);
      if (test === true) {
        check = true;
        break;
      }
    }

    if (check === false) {
      window.localStorage.removeItem("userObject");
      window.location.replace("/management/signin");
    }



    //let isSysAdmin = utils.IsInRole(userObject,"SystemAdmin");
  }






  loadDic = (languageCode) => {
    let token = null;
    let url = process.env.REACT_APP_API_END_POINT + "/api/corp/getdic";
    let data = {};
    data.languageCode = languageCode;
    utils.callPost(url, token, data, this.loadDicCallBack);
  }
  loadDicCallBack = (res) => {
    this.setState({
      dic: res.Data
    });
  }






  // componentDidMount() {
  //   if (this.state.userObject == null) {

  //     if (localStorage.getItem('userObject') == null) {
  //       let link = "/signin/";
  //       return <Redirect from="*" to={link} />
  //     }

  //   }
  // }
  // componentDidMount(){
  //   alert("didmount");
  // }
  // componentDidUpdate(){
  //   alert("didupdate");
  // }





  render() {
    //alert("app");
    //let id=match.params.id;






    return (
      <>
        <Router basename="/management">
          <Switch>
            <Route exact path="/signin" component={Signin} />

            <Route exact path="/companylist" children={<CompanyList appState={this.state} />} />

            <Route exact path="/affiliatedcompany" children={<AffiliatedCompany appState={this.state} />} />
            <Route exact path="/hotels" children={<HotelList appState={this.state} />} />
            <Route exact path="/roomcode" children={<RoomCode appState={this.state} />} />

            <Route exact path="/tickerlog" children={<TickerList appState={this.state} />} />


            <Route exact path="/usercontrol" children={<UserControl appState={this.state} />} />
            <Route exact path="/searchusercompany" children={<SearchUserCompany appState={this.state} />} />
            <Route exact path="/TravelClickSetting" children={<TravelClickSetting appState={this.state} method={"Edit"} />} />
            <Route exact path="/SmtpSetting" children={<SmtpSetting appState={this.state} method={"Edit"} />} />
            <Route exact path="/HopinnSetting" children={<HopinnSetting appState={this.state} method={"Edit"} />} />
            <Route exact path="/AdyenSetting" children={<AdyenSetting appState={this.state} method={"Edit"} />} />



            <Route exact path="/travelclickapilog" children={<TravelClickApiLog appState={this.state} />} />
            <Route exact path="/adyenapilog" children={<AdyenApiLog appState={this.state} />} />
            <Route exact path="/otherapilog" children={<OtherApiLog appState={this.state} />} />
            <Route exact path="/bothopinnlog" children={<BotHopinnLog appState={this.state} />} />


            <Route exact path="/emailhistorylist" children={<EmailHistoryList appState={this.state} />} />

            <Route exact path="/companylog" children={<CompanyLog appState={this.state} />} />

            {/* <Route exact path="/workflow" children={<Workflow appState={this.state} mode={""} />} /> */}

            {/* <Route exact path="/company/workflow" children={<Workflow appState={this.state} mode={"company"} />} /> */}
            {/* <Route exact path="/workflow/details/:id" children={<BookingDetails appState={this.state}  />} /> */}




            <Route exact path="/statementlist"
              render={(props) => (
                <StatementList {...props} appState={this.state} site="hopinn" />
              )}
            />



            {/* <Route exact path="/subcompanylist" children={<SubCompanyList appState={this.state} />} /> */}

            <Route exact path="/company/subcompanylist/:cid"
              render={(props) => (
                <SubCompanyList {...props} appState={this.state} site="company" />
              )}
            />


            <Route exact path="/company/statementlist/:cid"
              render={(props) => (
                <StatementList {...props} appState={this.state} site="company" />
              )}
            />
            <Route exact path="/statement/details/:id"
              render={(props) => (
                <BookingDetailsForStatement {...props} appState={this.state} site="hopinn" />
              )}
            />
            <Route exact path="/company/statement/details/:id"
              render={(props) => (
                <BookingDetailsForStatement {...props} appState={this.state} site="company" />
              )}
            />





            <Route exact path="/workflow"
              render={(props) => (
                <Workflow {...props} appState={this.state} site="hopinn" />
              )}
            />






            <Route exact path="/workflow/details/:id"
              render={(props) => (
                <BookingDetails {...props} appState={this.state} site="hopinn" />
              )}
            />





            <Route exact path="/company/workflow/:cid"
              render={(props) => (
                <Workflow {...props} appState={this.state} site="company" />
              )}
            />





            <Route exact path="/company/workflow/details/:id"
              render={(props) => (
                <BookingDetails {...props} appState={this.state} site="company" />
              )}
            />



            <Route exact path="/company/reservationbybilling/:cid"
              render={(props) => (
                <ReservationByBilling {...props} appState={this.state} site="company" />
              )}
            />
            <Route exact path="/company/reservationbybilling/details/:id"
              render={(props) => (
                <BookingDetails {...props} appState={this.state} site="company" />
              )}
            />


            <Route exact path="/company/billinglist/:cid"
              render={(props) => (
                <BillingList {...props} appState={this.state} site="company" />
              )}
            />




            <Route exact path="/company/policy/:cid"
              render={(props) => (
                <CompanyPolicy {...props} appState={this.state} site="company" />
              )}
            />

            <Route exact path="/company/employeegroup/:cid"
              render={(props) => (
                <CompanyEmployeeGroup {...props} appState={this.state} site="company" />
              )}
            />


            <Route exact path="/company/employee/:cid"
              render={(props) => (
                <CompanyEmployee {...props} appState={this.state} site="company" />
              )}
            />

            <Route exact path="/company/costcenter/:cid"
              render={(props) => (
                <CompanyCostCenter {...props} appState={this.state} site="company" />
              )}
            />

            <Route exact path="/company/companycode/:cid"
              render={(props) => (
                <CompanyCode {...props} appState={this.state} site="company" />
              )}
            />







            {/* <Route exact path="/company/policy/details/:id"
              render={(props) => (
                <CompanyPolicyDetails {...props} appState={this.state} site="company" />
              )}
            /> */}











            <Route exact path="/company/usercontrol/:cid"
              render={(props) => (
                <CompanyUserControl {...props} appState={this.state} site="company" />
              )}
            />

            <Route exact path="/company/openapi/:cid"
              render={(props) => (
                <OpenApiUpdate {...props} appState={this.state} site="company" method="Edit" />
              )}
            />


            <Route exact path="/company/companysetting/:cid"
              render={(props) => (
                <CompanySettingUpdate {...props} appState={this.state} site="company" method="Edit" />
              )}
            />







            <Route exact path="/"
              render={(props) => (
                <Workflow {...props} appState={this.state} site="hopinn" />
              )}
            />



            {/* <Route exact path="/company/:subpage/:id" component={TemplateCompany} /> */}

            {/* <Route path="/" component={Template} /> */}
          </Switch>
        </Router>


        {/* <Template/> */}


        {/* <Route exact path="/hotels" >
            <Template page="hotels"/>
        </Route>

        <Route exact path="/affiliatedcompany" component={Template}/>

        <Route exact path="/companylist" component={Template}/>

        <Route exact path="/usercontrol" component={Template}/> */}





        {/* <Route exact path="/affiliatedcompany">
          <AffiliatedCompany />
        </Route>
        <Route exact path="/companylist">
          <CompanyList />
        </Route>
        <Route exact path="/usercontrol">
          <UserControl />
        </Route>

        <Route exact path="/:page" component={Template}>

        </Route> */}


        {/* <Route exact path="/hotels">
          <Template page='hotels' />
        </Route>
        <Route exact path="/usercontrol">
          <Template page='usercontrol' />
        </Route>
        <Route exact path="/affiliatedcompany">
          <Template page='affiliatedcompany' />
        </Route>
        <Route exact path="/companylist">
          <Template page='companylist' />
        </Route>

        <Route path="/company/:subpage/:id" component={TemplateCompany}>
       
       
        </Route> */}
      </>
    );
  }
}
export default App;


//   return (
//     <>

//         <Route exact path="/hotels">
//             <Template page='hotels'/>
//           </Route>
//           <Route exact path="/usercontrol">
//             <Template page='usercontrol'/>
//           </Route>
//           <Route exact path="/affiliatedcompany">
//             <Template page='affiliatedcompany'/>
//           </Route>
//           <Route exact path="/companylist">
//             <Template page='companylist'/>
//           </Route>

//           <Route path="/company/:id">
//             <Template page='company'/>
//             {/* <div>company</div> */}
//           </Route>



//       {/* <MainHeader/> */}
//         {/* <main> */}
//           {/* <Route exact path="/welcome">
//             <Welcome/>
//           </Route>
//           <Route exact path="/signin">
//             <Signin/>
//           </Route>
//           <Route exact path="/products">
//             <Products/>
//           </Route>

//           <Route exact path="/hotels">
//             <Template page='hotels'/>
//           </Route>
//           <Route exact path="/usercontrol">
//             <Template page='usercontrol'/>
//           </Route>

//           <Route exact path="/">
//             <Welcome/>
//           </Route> */}




//         {/* </main> */}


//       {/* <main>
//       <Route path="/welcome">
//         <Welcome>
//       </Route>
//       <Route path="/product">
//         <Product>
//       </Route>
//       </main> */}

//     </>
//   );



// }


